var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 329,
    height: 115,
    viewBox: "0 0 329 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.724 12.8464C254.684 13.1855 267.37 16.5316 280.056 20.2889C321.661 32.6276 335.576 51.7719 307.066 70.5844C262.733 99.7581 159.47 118.852 79.3969 110.04C61.6635 108.098 37.6554 106.386 20.0584 96.9025C3.68923 88.0845 4.37128 77.6017 11.8738 67.8966C19.5128 57.946 34.2451 48.7879 45.9764 42.901C97.2666 17.2165 199.983 -6.12718 292.879 6.17942C294.788 6.41654 296.698 6.00876 297.244 5.26868C297.79 4.52859 296.834 3.735 295.061 3.49788C199.437 -9.16751 93.4466 14.6775 40.6558 41.1105C26.06 48.4511 6.96361 60.7047 1.5072 73.3831C-2.17587 82.0484 0.415387 90.9063 14.602 98.6119C33.2902 108.714 58.7992 110.693 77.6238 112.761C160.288 121.862 267.097 102.21 312.794 72.0798C343.486 51.8597 328.755 31.2635 284.012 18.0011C270.371 13.9244 256.457 10.4014 239.133 10.0342C237.223 9.99419 235.586 10.5918 235.586 11.3679C235.45 12.144 236.95 12.8064 238.724 12.8464Z",
    fill: "#FEA735"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape8);
export default __webpack_public_path__ + "static/media/shape-8.65140cb0d9c6c7e54079add7d95b0274.svg";
export { ForwardRef as ReactComponent };